import axios, { AxiosResponse } from 'axios';
import config from '@/data/repositories/api';
import { IAppointmentStore, IStore } from '@/domain/interfaces/IStore';
import { IFooterLayoutProps } from '@/domain/interfaces/IFooterSections';
import { IBackErrorDTO } from '@/domain/interfaces/IBackErrors';


/** Representa la interacción con el Back */
export default class StoreRepository {
  /** Instancia de la clase   */
  private static _instance: StoreRepository;

  /** Patron Singleton
   * @returns {instance} _instance StoreRepository
   */
  static get instance(): StoreRepository {
    if (!this._instance) {
      this._instance = new StoreRepository();
    }
    return this._instance;
  }

  /** Solicita la información de la tienda
   * @param {number} storeId
   * @returns {IStore} data 
   */
  async getStoreData(storeId:number): Promise<AxiosResponse<IStore>> {
    return await axios.get(`/store/${storeId}`, config);
  }

  /** Solicita la información de secciones del footer para la tienda
   * 
   * @returns {IFooterLayoutProps[]} data 
   */
  async getFooterSections(): Promise<AxiosResponse<IFooterLayoutProps[]>> {
    return await axios.get('/footer-sections', config);
  }

  /**
   * Envía solicitud de cita
   * 
   * @param {IAppointmentStore} appointmentForm
   * @returns {AxiosResponse<IBackErrorDTO[]>} - 200 o 422 - Errores
   */
  async sendAppointment(appointmentForm: IAppointmentStore): Promise<AxiosResponse<IBackErrorDTO[]>> {
    /** URL a consultar */
    let url: string = `/store/appointment`;
    return await axios.post(url, appointmentForm, config);
  }
}
